type FormData = any;

export const validatePurchaseForm = (
  form: FormData
): Record<string, string> => {
  const errors: Record<string, string> = {};

  const docCode = form.documentType?.code;

  // ───────────────────────────────
  // VALIDACIONES GENERALES
  // ───────────────────────────────
  if (!form.documentType?.id) {
    errors.documentType = 'Tipo de documento requerido';
  }

  if (!form.purchaseDate) {
    errors.purchaseDate = 'Fecha de compra requerida';
  }

  if (!form.supplier?.id) {
    errors.supplier = 'Proveedor requerido';
  }

  // ───────────────────────────────
  // VALIDACIÓN DE NÚMERO DE DOCUMENTO
  // (NO aplica para Sujeto Excluido)
  // ───────────────────────────────
  if (docCode !== '14') {
    if (!form.documentNumber) {
      errors.documentNumber = 'Número de documento requerido';
    }
  }

  // ───────────────────────────────
  // SUJETO EXCLUIDO (14)
  // ───────────────────────────────
  if (docCode === '14') {
    if (!form.branchId) {
      errors.branchId = 'Sucursal requerida para Sujeto Excluido';
    }
  }

  // ───────────────────────────────
  // IMPORTACIÓN (99)
  // ───────────────────────────────
  if (docCode === '99') {
    if (form.netAmount == null || form.netAmount < 0) {
      errors.netAmount = 'Monto neto requerido y no puede ser negativo';
    }

    if (form.freight == null || form.freight < 0) {
      errors.freight = 'Flete requerido y no puede ser negativo';
    }

    if (form.insurance == null || form.insurance < 0) {
      errors.insurance = 'Seguro requerido y no puede ser negativo';
    }

    if (form.fauca == null || form.fauca < 0) {
      errors.fauca = 'FAUCA requerido y no puede ser negativo';
    }

    if (form.otherCosts != null && form.otherCosts < 0) {
      errors.otherCosts = 'Otros costos no puede ser negativo';
    }
  }

  return errors;
};
